import React from 'react';
import { Dialog } from '../../../../Components/MUIs';
import { LEG_BASIC_DEFAULT_LAW_NM, LegBasicToYmd } from './LEG_BASIC_Constants';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 — 저장완료(확정) 확인 팝업 */
function LEG_BASIC_FinalSaveConfirmDialog({
  open = false,
  lawNm = '',
  halfYear = '',
  startDt = '',
  endDt = '',
  custNm = '',
  onClose = () => {},
  onConfirm = () => {},
}) {
  const name = String(lawNm ?? '').trim() || LEG_BASIC_DEFAULT_LAW_NM;
  const half = String(halfYear ?? '').trim() || '-';
  const startYmd = LegBasicToYmd(startDt);
  const endYmd = LegBasicToYmd(endDt);
  const period =
    startYmd && endYmd
      ? `${startYmd} ~ ${endYmd}`
      : startYmd || endYmd || '-';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="저장"
      maxWidth="sm"
      fullWidth
      useSaveButton={true}
      useCloseButton={true}
      saveButtonName="저장"
      closeButtonName="취소"
      onSave={onConfirm}
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro leg-law-select__intro--notice">
            <div className="leg-law-select__intro-icon leg-law-select__intro-icon--notice">
              <span className="material-symbols-outlined">verified</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                점검표를 저장(확정)합니다
              </div>
              <p className="leg-law-select__intro-desc">
                저장(확정) 후에는 점검표 내용을 수정할 수 없습니다. 계속
                진행하시겠습니까?
              </p>
            </div>
          </div>

          <div className="leg-law-select__card leg-law-select__card--custom leg-law-select__card--static">
            <div className="leg-law-select__card-main">
              <div className="leg-law-select__card-icon">
                <span className="material-symbols-outlined">menu_book</span>
              </div>
              <div className="leg-law-select__card-body">
                <div className="leg-law-select__card-top">
                  <span className="leg-law-select__card-title">{name}</span>
                  <span className="leg-law-select__badge leg-law-select__badge--saved">
                    저장완료 예정
                  </span>
                </div>
                <p className="leg-law-select__card-desc">
                  {custNm ? `${custNm} · ` : ''}
                  {half}
                  {period !== '-' ? ` · ${period}` : ''}
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default LEG_BASIC_FinalSaveConfirmDialog;
